/**
 * SalesPage.tsx — B2B Sales Page (cherishedlegacy.org)
 * Tenant: cherishedlegacy.org
 * Route: /
 *
 * STUB — Hero section placeholder.
 * Replace with full B2B sales/partner page when ready.
 */
import { useNavigate } from "react-router-dom";

export default function SalesPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-stone-900 px-6 text-center">
      {/* Hero */}
      <h1 className="font-['Playfair_Display'] text-5xl font-bold text-stone-100 leading-tight mb-4">
        Cherished Legacy
      </h1>
      <p className="text-stone-400 text-lg max-w-md mb-8">
        A white-label memorial video production platform for funeral homes and
        bereavement professionals.
      </p>
      <button
        onClick={() => navigate("/director")}
        className="px-8 py-4 rounded-xl bg-stone-100 text-stone-900 font-semibold text-base hover:bg-white active:scale-[0.98] transition-all duration-150 shadow"
      >
        Director Login
      </button>
      <p className="mt-4 text-xs text-stone-600">
        {/* PLACEHOLDER — full B2B sales page coming soon */}
        Partner portal under construction.
      </p>
    </div>
  );
}
